export default __webpack_public_path__ + "static/media/badlands.f968dea0.jpg";